<template>
  <div>
    <tx-action txType="Stake" />
    <div class="d-flex justify-center mt-16">
      <div class="deposit-box pa-10">
        <c-tx-steps
          class="mt-6"
          borderType="stake"
          :options="steps"
          :current="currentStep"
          @setStep="s => (currentStep = s)"
        />
        <div v-if="currentStep === 1" class="p-relative" style="height: 80%">
          <c-loading v-if="balancesState.fetching" />
          <select-ecosystem :ecosystem="ecosystem" />
          <div class="d-flex justify-space-between align-start mt-16">
            <div class="flex-1">
              <select-asset
                :ecosystem="ecosystem"
                :selectedAsset="currentProject"
              />
            </div>
            <enter-amount
              class="flex-1"
              v-model="form.amount"
              :maxAmount="availableBalance"
              :suffix="currentProject.staking.token"
            />
          </div>
          <div class="d-flex justify-end mt-4 text-5 darkgray--text">
            <span class="font-weight-medium"
              >Miminum Stake Amount: {{ minAmount | denomFormat }}</span
            >
            <span class="ml-1 text-uppercase">{{
              currentProject.staking.token
            }}</span>
          </div>
          <div class="mt-16">
            <c-btn
              class="width-100"
              @click="next"
              :disabled="btnNextDisabled"
              walletRequired
              >Continue</c-btn
            >
          </div>
        </div>
        <confirm
          v-if="currentStep === 2"
          class="mt-16"
          :txPayload="form"
          @close="$emit('close')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BN from "bignumber.js";
import TxAction from "@/views/stake/components/tx/TxAction.vue";
import EnterAmount from "@/views/stake/components/tx/EnterAmount.vue";
import Confirm from "./Confirm.vue";
import SelectEcosystem from "@/views/stake/components/tx/SelectEcosystem.vue";
import SelectAsset from "@/views/stake/components/tx/SelectAsset.vue";

export default {
  components: {
    TxAction,
    EnterAmount,
    Confirm,
    SelectEcosystem,
    SelectAsset,
  },
  computed: {
    ...mapGetters({
      balancesState: "staking/skale/availableBalance",
      walletSelected: "userWallets/walletSelected",
      currentProject: "projectConfig/latestProject",
      getTokenPriceInUsd: "appConfig/getTokenPriceInUsd",
    }),
    totalAmount() {
      return this.balancesState.result?.balance ?? 0;
    },
    lockedAmount() {
      return this.balancesState.result?.forbidden ?? 0;
    },
    availableBalance() {
      return new BN(this.totalAmount).minus(this.lockedAmount).toNumber();
    },
    minAmount() {
      return this.currentProject.config.calculator.min;
    },
    balanceUsd() {
      return (
        this.getTokenPriceInUsd(this.currentProject.staking.token) *
        this.availableBalance
      );
    },
    isSufficentAmount() {
      return (
        new BN(this.form.amount).isGreaterThanOrEqualTo(this.minAmount) &&
        new BN(this.form.amount).isLessThanOrEqualTo(this.availableBalance)
      );
    },
    amountUsd() {
      return (
        this.getTokenPriceInUsd(this.currentProject.staking.token) *
        this.form.amount
      );
    },
    btnNextDisabled() {
      if (!this.currentProject.status?.active) return true;
      return !this.isSufficentAmount;
    },
    btnStakeDisabled() {
      return this.gasOption.gas <= 0 || this.gasOption.gasPrice <= 0;
    },
  },
  data: () => ({
    ecosystem: "Ethereum",
    steps: [
      {
        step: 1,
        text: "Amount",
      },
      {
        step: 2,
        text: "Confirm",
      },
    ],
    currentStep: 1,
    form: {
      amount: 0,
    },
    gasOption: {},
  }),
  methods: {
    next() {
      this.currentStep = 2;
    },
  },
  watch: {
    ["walletSelected.address"]() {
      this.currentStep = 1;
      this.form.amount = 0;
    },
  },
};
</script>
